<div class="dialog-content">
  <div mat-dialog-title class="m-b-16">
    <div class="d-flex align-items-center">
      <mat-icon class="m-r-8 text-warning">info</mat-icon>
      <span>{{ 'upcomingFeatures.availability.title' | translate }}</span>
    </div>
  </div>

  <div mat-dialog-content class="m-b-24">
    <p class="mat-body-1 m-b-16">
      {{ 'upcomingFeatures.availability.message' | translate: { feature: data.featureName } }}
    </p>
    <p class="mat-body-2 text-medium">
      {{ 'upcomingFeatures.availability.description' | translate }}
    </p>
  </div>

  <div mat-dialog-actions class="d-flex justify-content-end gap-12">
    <app-mat3-button
      [text]="'common.cancel' | translate"
      variant="text"
      (buttonClick)="onCancel()">
    </app-mat3-button>
    <app-mat3-button
      [text]="'upcomingFeatures.availability.notifyMe' | translate"
      variant="primary"
      beforeIcon="notifications"
      (buttonClick)="onNotifyMe()">
    </app-mat3-button>
  </div>
</div>